import { sortBy as _sortBy } from 'lodash';
import { without as _without } from 'lodash';
import { filter as _filter } from 'lodash';
import { find as _find } from 'lodash';

class FavoriteReportsController {
  constructor(authService, reportingService, loadingService, $state) {
    "ngInject";

    this.authService = authService;
    this.reportingService = reportingService;
    this.loadingService = loadingService;
    this.$state = $state;

    this.loadReports();
    this.allReports = [];
    this.favReports = [];
    this.selAllReports = [];
    this.selFavReports = [];
  }

  loadReports() {
    this.loadingService.showLoading('favReports', 'Loading Reports ...');

    this.reportingService.getFavoriteReports(this.authService.authData.currentLocation.key)
      .then(response => {
        this.allReports = response.data.allReports;
        this.favReports = response.data.favoriteReports;

        this.sortReports();
      })
      .catch(err => {

      })
      .finally(() => {
        this.loadingService.hideLoading('favReports');
      })
  }

  sortReports(){
    this.allReports = _sortBy(this.allReports, 'name');
    this.favReports = _sortBy(this.favReports, 'name');
  }

  selectReports() {
    const selReportIds = this.selAllReports.map(r => r.reportId);
    const selReportItems = _filter(this.allReports, o => _find(selReportIds, repId => o.reportId === repId));
    this.allReports = _without(this.allReports, ...selReportItems);
    this.favReports.push(...selReportItems);
    this.selAllReports = [];

    this.sortReports();
  }

  deselectReports() {
    const selReportIds = this.selFavReports.map(r => r.reportId);
    const selReportItems = _filter(this.favReports, o => _find(selReportIds, repId => o.reportId === repId));
    this.favReports = _without(this.favReports, ...selReportItems);
    this.allReports.push(...selReportItems);
    this.selFavReports = [];

    this.sortReports();
  }

  saveChanges() {
    this.loadingService.showLoading('favReports', 'Saving Changes ...');

    const favReportIds = this.favReports.map(r => r.reportId);

    this.reportingService.updateFavoriteReports(this.authService.authData.currentLocation.key, favReportIds)
      .then(response => {
        this.$state.go('reportsLanding');
      })
      .catch(err => {

      })
      .finally(() => {
        this.loadingService.hideLoading('favReports');
      })
  }
}

export default FavoriteReportsController;



// WEBPACK FOOTER //
// ./client/app/components/reports/favoriteReports/favoriteReports.controller.js